import { weekDays } from "../data/rooms";
import { getRoomEventsForDay } from "../state/roomState";

export default function CalendarPanel({ rooms, selectedDay, onSelectDay, onShiftDay, standalone = true }) {
  const events = getRoomEventsForDay(rooms, selectedDay);
  const selected = weekDays[selectedDay];

  return (
    <section className={`panel calendar-panel calendar-panel-journal ${standalone ? "section" : ""}`}>
      <header className="calendar-panel-head">
        <div className="calendar-panel-intro">
          <p className="calendar-panel-eyebrow">Week at a glance</p>
          <h2 className="calendar-panel-title">Ops calendar</h2>
          <p className="calendar-panel-lede">
            Pick a day to load its room events. The strip keeps each date fully readable — scroll horizontally on smaller
            widths.
          </p>
        </div>
        <div className="calendar-panel-toolbar" aria-label="Move between days">
          <button type="button" className="calendar-nav-btn" onClick={() => onShiftDay(-1)} aria-label="Previous day">
            <span aria-hidden>←</span>
            <span>Prev</span>
          </button>
          <div className="calendar-selected-chip" aria-live="polite">
            <span className="calendar-selected-week">{selected.longDate}</span>
            <span className="calendar-selected-meta">
              {events.length} event{events.length === 1 ? "" : "s"} · mock data
            </span>
          </div>
          <button type="button" className="calendar-nav-btn" onClick={() => onShiftDay(1)} aria-label="Next day">
            <span>Next</span>
            <span aria-hidden>→</span>
          </button>
        </div>
      </header>

      <div className="calendar-week-scroller" role="tablist" aria-label="Days this week">
        <div className="calendar-week-track">
          {weekDays.map((day, i) => {
            const count = getRoomEventsForDay(rooms, i).length;
            const active = i === selectedDay;
            return (
              <button
                key={i}
                type="button"
                role="tab"
                aria-selected={active}
                id={`calendar-day-${i}`}
                className={"calendar-day-chip" + (active ? " active" : "")}
                onClick={() => onSelectDay(i)}
              >
                <span className="calendar-day-chip-week">{day.label}</span>
                <span className="calendar-day-chip-date" aria-label={day.longDate}>
                  <span className="calendar-day-chip-num">{day.dayNum}</span>
                  <span className="calendar-day-chip-mon">{day.month}</span>
                </span>
                <span className="calendar-day-chip-foot">
                  {count} event{count === 1 ? "" : "s"}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="calendar-events">
        <div className="calendar-events-head">
          <span className="calendar-events-title">Today&apos;s queue</span>
          <div className="calendar-legend-inline" aria-hidden>
            <span className="calendar-legend-dot steady" />
            Steady
            <span className="calendar-legend-dot watch" />
            Watch
            <span className="calendar-legend-dot resolve" />
            Resolve soon
          </div>
        </div>

        <div className="calendar-events-track">
          {events.length === 0 ? (
            <article className="calendar-event-card calendar-event-card-empty">
              <div className="calendar-event-card-top">
                <span className="calendar-date-pill">No events · {selected.longDate}</span>
              </div>
              <h3 className="calendar-event-card-heading">Clear runway</h3>
              <p className="calendar-event-card-body">
                Nothing scheduled for this day — a good window for board rebuilds or deep calibration passes.
              </p>
              <span className="calendar-pill-tag steady">Open capacity</span>
            </article>
          ) : (
            events.map((ev, i) => {
              const tone = ev.level === "resolve" ? "resolve" : ev.level === "watch" ? "watch" : "steady";
              return (
                <article className="calendar-event-card" key={i}>
                  <div className="calendar-event-card-top">
                    <span className={`calendar-pill-tag ${tone}`}>{ev.roomId}</span>
                    <span className="calendar-date-pill">{selected.longDate}</span>
                  </div>
                  <h3 className="calendar-event-card-heading">{ev.title}</h3>
                  <p className="calendar-event-card-body">{ev.detail}</p>
                </article>
              );
            })
          )}
        </div>
      </div>
    </section>
  );
}
